import { render, staticRenderFns } from "./Carddetails.vue?vue&type=template&id=71e33762&scoped=true"
import script from "./Carddetails.vue?vue&type=script&lang=js"
export * from "./Carddetails.vue?vue&type=script&lang=js"
import style0 from "./Carddetails.vue?vue&type=style&index=0&id=71e33762&prod&lang=scss&scoped=true"
import style1 from "./Carddetails.vue?vue&type=style&index=1&id=71e33762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e33762",
  null
  
)

export default component.exports